<template>
  <div class="login-wrapper">
    <!-- Background geometric shapes -->
    <div class="bg-shape bg-shape--1"></div>
    <div class="bg-shape bg-shape--2"></div>
    <div class="bg-shape bg-shape--3"></div>
    <div class="bg-noise"></div>

    <div class="login-card">
      <!-- Left panel: branding -->
      <div class="brand-panel">
        <div class="brand-panel__inner">
          <div class="brand-logo">
            <img src="@/assets/grupompng.png" alt="Grupo M" class="brand-logo__img" />
          </div>
          <div class="brand-tagline">
            <span class="brand-tagline__line">Sistema de</span>
            <span class="brand-tagline__line brand-tagline__line--accent">Gestión Empresarial</span>
          </div>
          <div class="brand-divider"></div>
          <p class="brand-desc">Accede a tu plataforma de finanzas e inventario en un solo lugar.</p>

          <!-- Finance stats decorative -->

        </div>
        <div class="brand-dots">
          <span v-for="i in 9" :key="i" class="brand-dot"></span>
        </div>
      </div>

      <!-- Right panel: form -->
      <div class="form-panel">
        <transition name="slide-fade" mode="out-in">

          <!-- LOGIN FORM -->
          <div v-if="form === 'login'" key="login" class="form-inner">
            <div class="form-header">
              <h2 class="form-title">Bienvenido</h2>
              <p class="form-subtitle">Ingresa tus credenciales para continuar</p>
            </div>

            <form @submit.prevent="handleSubmit" autocomplete="off">
              <div class="field-group">
                <label class="field-label">Usuario</label>
                <div class="field-wrap" :class="{ 'field-wrap--focus': focusUser }">
                  <v-icon class="field-icon">mdi-account-outline</v-icon>
                  <input class="field-input" v-model="user.username" ref="username" type="text" name="username"
                    autocomplete="username" required @focus="focusUser = true" @blur="focusUser = false"
                    @keyup.enter="$refs.password.focus()" />
                </div>
              </div>

              <div class="field-group">
                <label class="field-label">Contraseña</label>
                <div class="field-wrap" :class="{ 'field-wrap--focus': focusPass }">
                  <v-icon class="field-icon">mdi-lock-outline</v-icon>
                  <input class="field-input" v-model="user.password" :type="showPassword ? 'text' : 'password'"
                    name="password" ref="password" autocomplete="current-password" required @focus="focusPass = true"
                    @blur="focusPass = false" @keyup.enter="handleSubmit" />
                  <button type="button" class="toggle-btn" @click="showPassword = !showPassword" tabindex="-1">
                    <v-icon size="18">{{ showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
                  </button>
                </div>
              </div>

              <transition name="error-fade">
                <div v-if="hasError" class="error-banner">
                  <v-icon size="16" class="mr-1">mdi-alert-circle-outline</v-icon>
                  Usuario o contraseña incorrectos
                </div>
              </transition>

              <button type="submit" class="submit-btn" :disabled="loading">
                <span v-if="loading" class="btn-loader">
                  <span class="loader-dot"></span>
                  <span class="loader-dot"></span>
                  <span class="loader-dot"></span>
                </span>
                <span v-else class="btn-content">
                  Acceder
                  <v-icon size="16" class="ml-2">mdi-arrow-right</v-icon>
                </span>
              </button>

              <button type="button" class="link-btn" @click="toggleForm">
                ¿Olvidaste tu contraseña?
              </button>
            </form>
          </div>

          <!-- FORGOT PASSWORD FORM -->
          <div v-else key="forgot" class="form-inner">
            <div class="form-header">
              <button type="button" class="back-btn" @click="toggleForm">
                <v-icon size="18">mdi-arrow-left</v-icon>
              </button>
              <h2 class="form-title">Restablecer</h2>
              <p class="form-subtitle">Completa los campos para recuperar tu acceso</p>
            </div>

            <form @submit.prevent="handleSubmit">
              <div class="field-group">
                <label class="field-label">Código de empleado</label>
                <div class="field-wrap" :class="{ 'field-wrap--focus': focusEmp }">
                  <v-icon class="field-icon">mdi-badge-account-outline</v-icon>
                  <input class="field-input" v-model="forgot_user.employee_code" type="text" required autofocus
                    @focus="focusEmp = true" @blur="focusEmp = false" />
                </div>
              </div>

              <div class="field-group">
                <label class="field-label">Usuario</label>
                <div class="field-wrap" :class="{ 'field-wrap--focus': focusUser2 }">
                  <v-icon class="field-icon">mdi-account-outline</v-icon>
                  <input class="field-input" v-model="forgot_user.username" type="text" required
                    @focus="focusUser2 = true" @blur="focusUser2 = false" />
                </div>
              </div>

              <div class="field-group">
                <label class="field-label">Correo electrónico</label>
                <div class="field-wrap" :class="{ 'field-wrap--focus': focusMail }">
                  <v-icon class="field-icon">mdi-email-outline</v-icon>
                  <input class="field-input" v-model="forgot_user.mail" type="email" required @focus="focusMail = true"
                    @blur="focusMail = false" @keyup.enter="handleSubmit" />
                </div>
              </div>

              <button type="submit" class="submit-btn" :disabled="loading">
                <span v-if="loading" class="btn-loader">
                  <span class="loader-dot"></span>
                  <span class="loader-dot"></span>
                  <span class="loader-dot"></span>
                </span>
                <span v-else class="btn-content">
                  Enviar instrucciones
                  <v-icon size="16" class="ml-2">mdi-send-outline</v-icon>
                </span>
              </button>
            </form>
          </div>

        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";

export default {
  name: "Login",

  data: () => ({
    hasError: false,
    loading: false,
    showPassword: false,
    form: 'login',
    focusUser: false,
    focusPass: false,
    focusEmp: false,
    focusUser2: false,
    focusMail: false,

    user: {
      username: "",
      password: "",
    },
    forgot_user: {
      employee_code: null,
      username: null,
      mail: null,
    }
  }),

  computed: {
    loggedIn() {
      return this.$store.state.auth.authStatus;
    },
  },

  mounted() {
    this.$refs.username?.focus();
  },

  created() {
    // Solo redirigir a Home si hay un token REALMENTE válido (no vencido).
    // Antes se usaba this.loggedIn (authStatus persistido), que podía quedar
    // en true con el token ya expirado -> redirigía a "/" -> el guard fallaba
    // -> volvía a Login -> bucle/pantalla en blanco.
    if (this.hasValidSession()) {
      this.$router.push("/").catch(() => { });
    } else if (this.loggedIn) {
      // Estado stale: limpiar la sesión para dejar el login utilizable.
      this.$store.dispatch("auth/logOut");
    }
  },

  methods: {
    hasValidSession() {
      const token = localStorage.getItem("token");
      if (!token || token === "null") return false;
      try {
        const { exp } = jwt_decode(token);
        return Math.floor(Date.now() / 1000) < exp;
      } catch (e) {
        return false;
      }
    },

    toggleForm() {
      this.form = this.form === 'login' ? 'register' : 'login';
    },

    handleSubmit(e) {
      e.preventDefault();
      if (this.form === 'login') {
        this.login();
      } else {
        this.forgotPassword();
      }
    },

    addErrorNotification(text) {
      this.$toast.error(text, {
        position: "top-right",
        timeout: 4000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
      });
    },

    async login() {
      this.loading = true;
      try {
        const url =
          process.env.NODE_ENV === "production"
            ? process.env.VUE_APP_API_URL_PRODUCTION
            : process.env.VUE_APP_API_URL_DEV;

        const response = await fetch(`${url}auth/signIn`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.user),
        });

        if (response.status !== 200) {
          this.hasError = true;
          console.error(await response.text());
          setTimeout(() => (this.hasError = false), 15000);
          return;
        }

        const dataLogin = await response.json();

        const [allBUnits, allLocations, warehousesRes] = await Promise.all([
          this.api_Get("humanResource/bussines_unit").then(r => r.json()),
          this.api_Get("humanResource/locations").then(r => r.json()),
          this.api_Get("inventory/allWarehouses").then(r => r.json()),
        ]);

        const dataBussinesUnit = allBUnits
          .filter(b => dataLogin.acess_business_unit_finance.includes(b.id) && b.status_id === 1)
          .map(b => ({ ...b, text: b.description_long, value: b.id }));

        const all_locations = allLocations
          .filter(loc => loc.status_id === 1)
          .map(loc => ({
            ...loc,
            text: loc.desc_loc_long,
            value: loc.id,
          }));

        const dataLocations = all_locations.filter(loc =>
          dataLogin.acess_locations.includes(loc.id)
        );

        const colorPreference = dataLogin.user?.color_preference;
        if (colorPreference) {
          this.$vuetify.theme.themes.light.primary = colorPreference;
          localStorage.setItem("user_primary_color", colorPreference);
        }

        const dataNew = {
          data: dataLogin,
          dataBussines: dataBussinesUnit,
          dataLocations,
          warehouse: warehousesRes,
          all_locations,
          user_features: dataLogin.user?.user_features || [],
        };

        this.$store.dispatch("auth/login", dataNew);

      } catch (err) {
        console.error("Error al iniciar sesión:", err);
        this.addErrorNotification("Ocurrió un error al iniciar sesión.");
      } finally {
        this.loading = false;
      }
    },

    async forgotPassword() {
      if (!this.forgot_user.employee_code || !this.forgot_user.username || !this.forgot_user.mail) {
        this.addErrorNotification("Todos los campos son requeridos");
        return;
      }

      try {
        this.loading = true;
        const result = await this.api_Post("auth/forgot_password", {
          employee_code: this.clearInputFilter(this.forgot_user.employee_code, 6),
          username: this.forgot_user.username,
          mail: this.forgot_user.mail,
          systemId: 2
        });

        if (result.status != 200) {
          this.addErrorNotification("Ocurrió un error al enviar la contraseña");
          return;
        }

        this.$toast.success("¡Contraseña enviada al correo!");
        this.forgot_user = { employee_code: null, username: null, mail: null };
        this.toggleForm();

      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@300;400;500&display=swap');

/* ── RESET & BASE ─────────────────────────────────── */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* ── WRAPPER ──────────────────────────────────────── */
.login-wrapper {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f4f8;
  overflow: hidden;
  font-family: 'DM Sans', sans-serif;
}

/* ── BACKGROUND SHAPES ────────────────────────────── */
.bg-shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  opacity: 0.35;
}

.bg-shape--1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, #bfdbfe 0%, transparent 70%);
  top: -200px;
  left: -150px;
  animation: drift1 18s ease-in-out infinite alternate;
}

.bg-shape--2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, #dbeafe 0%, transparent 70%);
  bottom: -100px;
  right: -100px;
  animation: drift2 22s ease-in-out infinite alternate;
}

.bg-shape--3 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, #e0f2fe 0%, transparent 70%);
  top: 50%;
  left: 60%;
  animation: drift1 15s ease-in-out infinite alternate-reverse;
}

.bg-noise {
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E");
  opacity: 0.025;
  pointer-events: none;
}

@keyframes drift1 {
  from {
    transform: translate(0, 0) scale(1);
  }

  to {
    transform: translate(40px, 30px) scale(1.08);
  }
}

@keyframes drift2 {
  from {
    transform: translate(0, 0) scale(1);
  }

  to {
    transform: translate(-30px, -40px) scale(1.05);
  }
}

/* ── CARD ─────────────────────────────────────────── */
.login-card {
  position: relative;
  z-index: 10;
  display: flex;
  width: 100%;
  max-width: 880px;
  min-height: 520px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.06),
    0 40px 80px rgba(0, 0, 0, 0.12),
    0 0 60px rgba(59, 130, 246, 0.06);
  margin: 24px;
  animation: cardIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.97);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ── BRAND PANEL ──────────────────────────────────── */
.brand-panel {
  position: relative;
  width: 340px;
  flex-shrink: 0;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}

.brand-panel::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #2563eb, #60a5fa, transparent);
}

.brand-panel::after {
  content: '';
  position: absolute;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  background: radial-gradient(circle, #dbeafe 0%, transparent 70%);
  bottom: -120px;
  right: -120px;
  pointer-events: none;
}

.brand-panel__inner {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.brand-logo {
  display: flex;
  align-items: center;
}

.brand-logo__img {
  width: 100%;
  max-width: 200px;
  filter: brightness(1.1);
}

.brand-tagline {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.brand-tagline__line {
  font-family: 'Outfit', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.brand-tagline__line--accent {
  font-size: 20px;
  font-weight: 700;
  color: #1e40af;
  text-transform: none;
  letter-spacing: -0.02em;
}

.brand-divider {
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, transparent);
  border-radius: 2px;
}

.brand-desc {
  font-size: 13px;
  line-height: 1.7;
  color: #94a3b8;
}

.brand-dots {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  width: fit-content;
}

.brand-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #cbd5e1;
}

/* ── FORM PANEL ───────────────────────────────────── */
.form-panel {
  flex: 1;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
}

.form-inner {
  width: 100%;
  max-width: 360px;
}

.form-header {
  margin-bottom: 36px;
  position: relative;
}

.form-title {
  font-family: 'Outfit', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.03em;
  margin-bottom: 6px;
}

.form-subtitle {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #64748b;
  width: 32px;
  height: 32px;
  cursor: pointer;
  margin-bottom: 16px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background: #e2e8f0;
  color: #0f172a;
}

/* ── FIELD ────────────────────────────────────────── */
.field-group {
  margin-bottom: 16px;
}

.field-label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 8px;
}

.field-wrap {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}

.field-wrap--focus {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.field-icon {
  flex-shrink: 0;
  margin-left: 14px;
  color: #cbd5e1 !important;
  font-size: 18px !important;
  transition: color 0.2s;
}

.field-wrap--focus .field-icon {
  color: #3b82f6 !important;
}

.field-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  padding: 13px 14px;
  font-size: 14px;
  color: #0f172a;
  font-family: 'DM Sans', sans-serif;
  caret-color: #3b82f6;
}

.field-input::placeholder {
  color: #cbd5e1;
}

.toggle-btn {
  background: none;
  border: none;
  padding: 0 14px;
  cursor: pointer;
  color: #cbd5e1;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.toggle-btn:hover {
  color: #64748b;
}

/* ── ERROR ────────────────────────────────────────── */
.error-banner {
  display: flex;
  align-items: center;
  padding: 10px 14px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: 8px;
  color: #f87171;
  font-size: 13px;
  margin-bottom: 16px;
}

/* ── SUBMIT BUTTON ────────────────────────────────── */
.submit-btn {
  width: 100%;
  margin-top: 8px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
  border: none;
  border-radius: 10px;
  color: #fff;
  font-family: 'Outfit', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
  letter-spacing: 0.01em;
}

.submit-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%);
  opacity: 0;
  transition: opacity 0.25s ease;
}

.submit-btn:hover::before {
  opacity: 1;
}

.submit-btn:hover {
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.35);
  transform: translateY(-1px);
}

.submit-btn:active {
  transform: translateY(0);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.btn-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── LOADER ───────────────────────────────────────── */
.btn-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.loader-dot {
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
  animation: blink 1.2s ease-in-out infinite;
}

.loader-dot:nth-child(2) {
  animation-delay: 0.2s;
}

.loader-dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {

  0%,
  80%,
  100% {
    opacity: 0.2;
    transform: scale(0.8);
  }

  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* ── LINK BUTTON ──────────────────────────────────── */
.link-btn {
  display: block;
  width: 100%;
  margin-top: 16px;
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 13px;
  font-family: 'DM Sans', sans-serif;
  cursor: pointer;
  text-align: center;
  transition: color 0.2s;
}

.link-btn:hover {
  color: #2563eb;
}

/* ── TRANSITIONS ──────────────────────────────────── */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter {
  opacity: 0;
  transform: translateX(16px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-16px);
}

.error-fade-enter-active,
.error-fade-leave-active {
  transition: all 0.25s ease;
}

.error-fade-enter,
.error-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

/* ── RESPONSIVE ───────────────────────────────────── */
@media (max-width: 700px) {
  .brand-panel {
    display: none;
  }

  .form-panel {
    padding: 40px 28px;
  }

  .login-card {
    margin: 16px;
    border-radius: 20px;
  }
}
</style>